import api from './api';

export interface Lead {
  id: string;
  contact_id?: string;
  account_id?: string;
  status: string;
  score?: number;
  segment?: string;
  source?: string;
  created_at: string;
  contact?: {
    id: string;
    email: string;
    first_name?: string;
    last_name?: string;
    title?: string;
    company?: string;
  };
  account?: {
    id: string;
    name: string;
    industry?: string;
    employee_count?: number;
  };
}

export interface LeadFilters {
  status?: string;
  segment?: string;
  min_score?: number;
  max_score?: number;
}

export const leadsService = {
  getLeads: async (filters?: LeadFilters) => {
    const response = await api.get('/leads', { params: filters });
    return response.data;
  },

  getLead: async (id: string) => {
    const response = await api.get(`/leads/${id}`);
    return response.data;
  },

  createLead: async (data: Partial<Lead>) => {
    const response = await api.post('/leads', data);
    return response.data;
  },

  updateLead: async (id: string, data: Partial<Lead>) => {
    const response = await api.put(`/leads/${id}`, data);
    return response.data;
  },

  deleteLead: async (id: string) => {
    const response = await api.delete(`/leads/${id}`);
    return response.data;
  },

  scoreLeads: async () => {
    const response = await api.post('/leads/score');
    return response.data;
  },

  getHotLeads: async (limit: number = 20) => {
    const response = await api.get('/leads/hot', {
      params: { limit },
    });
    return response.data;
  },

  enrichLead: async (leadId: string) => {
    const response = await api.post(`/leads/${leadId}/enrich`);
    return response.data;
  },

  importLeads: async (csvContent: string) => {
    const response = await api.post('/leads/import', {
      csv_content: csvContent,
      data_type: 'lead',
    });
    return response.data;
  },
};
